import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OpnTeamMemberSaveModel } from 'src/common';
import { environment } from 'src/environments/environment';

const localApiUrl = `${environment.apiUrl}/RequestOpnTeamMembers`;

@Injectable()
export class OpnTeamMembersService {

  constructor(private http: HttpClient) { }

  delete(id: number): Promise<void> {
      return this.http.delete<void>(`${localApiUrl}/Delete/${id}`).toPromise();
  }

  save(model: OpnTeamMemberSaveModel): Promise<void> {
      return this.http.post<void>(`${localApiUrl}/Save`, model).toPromise();
  }
}
